import { Button, Modal } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import PaymentQrCode from '../../custom/invoice/PaymentQrCode'
import { getPaymentQrDataFromSubmission } from '../../custom/invoice/paymentQr'
import i18n from '../../i18n'
import { linkDefaultParams } from '../../utils/linkDefaultParams'

interface iModalBox {
  isOpenModal: boolean,
  isModalBtn: boolean,
  againVals: any,
  formSlug: string,
  showInvoice: boolean,
  resData?: any,
  isEdit?: boolean,
}

const ModalBox: React.FC<iModalBox> = (props) => {

  const onModalOKClick = () => {
    window.location.reload()
  }

  const onModalAgainClick = () => {
    const url = window.location.protocol + '//' + window.location.host + window.location.pathname
    const link = linkDefaultParams(url, props.againVals)
    window.location.assign(link)
  }

  const onClickShowInvoice = () => {
    const publicId = props.resData.publicId
    const lang = i18n.language === 'cs' ? '' : '/en'
    const url = window.location.protocol + '//' + window.location.host + lang + '/submission/' + publicId + '/invoice'
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const { t } = useTranslation()
  const paymentQrCodes = props.showInvoice
    ? getPaymentQrDataFromSubmission(props.resData)
    : []

  const modalContent = () => {
    if (props.formSlug === 'kontaktni-formular') {
      return (
        <p>{t('submit.modal.dekujemeKontakt')}</p>
      )
    }
    return (
      <>
        <p>{t(props.isEdit ? 'submit.modal.edit' : 'submit.modal.submit')}</p>
        <p>{t('submit.modal.dekujeme')}</p>
        {props.formSlug === 'hlaseni-nps-uvodni' &&
          <p><br/>{t('submit.modal.submitNps')}</p>
        }
      </>
    )
  }

  return (
    <Modal
      open={props.isOpenModal}>
      <div className="modal-dialog finalmodalbox">
        <div className="modal-content">
          <div className="modal-body">
            <i className="fa fa-check-circle"></i>
            {modalContent()}

            {!!paymentQrCodes.length &&
              <>
                <h3 className="payment-qr-codes__title">
                  {t('submit.modal.qrPayment')}
                </h3>
                <div className="payment-qr-codes">
                  {paymentQrCodes.map((paymentQrCode) =>
                    <div className="payment-qr-codes__item" key={paymentQrCode.variableSymbol}>
                      <PaymentQrCode {...paymentQrCode}/>
                      <span>
                        {t('invoice.variabilniSymbol')} {paymentQrCode.variableSymbol}
                      </span>
                    </div>
                  )}
                </div>
              </>
            }

            {props.againVals &&
              <div>
                <Button variant="outlined" color="inherit" className={'mt-4'}
                        onClick={onModalAgainClick}>{t('submit.modal.again')}</Button>
              </div>
            }

            {props.showInvoice &&
              <div>
                <Button variant="outlined" color="inherit" className={'mt-4'}
                        onClick={onClickShowInvoice}>{t('submit.modal.zobrazitPlatbu')}</Button>
              </div>
            }
            {props.isModalBtn &&
              <Button variant="outlined" color="inherit" className={'mt-4'}
                      onClick={onModalOKClick}>{t('submit.modal.ok')}</Button>
            }
            <a href={t('submit.modal.link')}>{t('submit.modal.prejit')}</a>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalBox
